export default `
mutation updateShift(
  $shiftId: ID!,
  $userId: ID,
  $updatedBy: ID!,
  $note: String,
  $startTime: Float,
  $endTime: Float,
  $serviceProviderId: ID!,
  $timezone: String,
  $postOrders: [PostOrderInput!]
) {
  updateShift(
    shiftId: $shiftId, 
    userId: $userId,
    updatedBy: $updatedBy,
    note: $note, 
    startTime: $startTime,
    endTime: $endTime,
    serviceProviderId: $serviceProviderId,
    timezone: $timezone,
    postOrders: $postOrders
  ) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
    postOrders {
      description
      time {
        start
        end
      }
      propertyId
      dar {
        isRequired
        darId
      }
      completed {
        timestamp
        coordinates {
          lat
          lng
        }
      }
    }
  }
}
`;